import React from "react";
import Products from './Products';
function Home() {


  return (
    <div className="container-fluid bg-dark" >

      <Products />

    </div>
  );
}
export default Home;
